<template>
  <div>
    <div
      class="card card_white flex-fill"
      :class="selected ? 'selected' : ''"
      v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
      style="cursor: pointer"
    >
      <div
        style="-webkit-line-clamp: -1; -webkit-box-orient: vertical"
        class="sub_title_3"
      >
        <span v-if="param.metricName != null">{{ param.metricName }}</span>
        <span v-if="param.currency != ''">
          {{ "(" + param.currency + ")" }}</span
        >
      </div>
      <div v-if="param.value != null" class="data_text_2">
        <span style="font-size: 20px; font-weight: 700">{{
          formattedNumber(param.value)
        }}</span
        >/<span style="font-size: 16px"
          >{{ formattedNumber(param.target) }} {{ param.unit }}</span
        >
      </div>
      <div class="d-flex mt-2">
        <div
          @mouseenter="showTooltipArc"
          @mouseleave="hideTooltipArc"
          class="d-inline-flex align-items-center me-2 tooltip-container"
          :class="
            param.achievementStatus === 'UP' ? 'badge_green' : 'badge_red'
          "
        >
          <div v-if="visibleArc" class="tooltip-content">
            <span>Achievement</span>
          </div>
          <IconSvg
            :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
            :type="param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'"
          />
          <div
            class="data_detil"
            v-bind:style="
              param.achievementStatus === 'UP' ? 'color: green;' : 'color: red;'
            "
          >
            {{ param.achievement !== null ? param.achievement : "-" }}
          </div>
        </div>
        <div
          @mouseenter="showTooltip"
          @mouseleave="hideTooltip"
          class="d-inline-flex align-items-center tooltip-container"
          :class="param.trendStatus === 'UP' ? 'badge_green' : 'badge_red'"
        >
          <div
            style="left: 60px !important"
            v-if="visible"
            class="tooltip-content"
          >
            <span>Trend</span>
          </div>
          <IconSvg
            :color="param.trendStatus === 'UP' ? 'green' : 'red'"
            :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
          />
          <div
            class="data_detil"
            v-bind:style="
              param.trendStatus === 'UP' ? 'color: green;' : 'color: red;'
            "
          >
            {{ param.trend !== null ? param.trend : "-" }}
          </div>
        </div>
      </div>
      <div class="progress">
        <div
          class="progress-bar bg-info"
          role="progressbar"
          :style="`width:${Math.min((param.value / param.target) * 100, 100)}%`"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <div
        class="d-inline-flex align-items-center m-t-5 justify-content-between"
      >
        <div style="color: #7a7a7a; font-size: small">
          Period: {{ convertToMMMYYYY(param.month, param.year) }}
        </div>
        <div
          v-if="param.frequency !== null"
          style="
            color: rgb(235 235 235);
            font-size: small;
            background-color: #00a3e9;
            padding: 1%;
            border-radius: 5px;
          "
          :style="
            param.metricId === 'DISTRIBUTION_PENURUNAN_ADUAN_PLNMOBILE'
              ? 'margin-top: -4%'
              : ''
          "
        >
          {{ param.frequency }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      visibleArc: false,
    };
  },
  mounted() {},
  methods: {
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    formattedNumber,
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
  },
};
</script>

<style scoped>
.selected {
  background-color: #ecf9ff;
  border: 1px solid #00a3e9;
}
</style>
